export class ConverterError extends Error {}
